import { business } from '../../../shared/config/site';

const links = [
  { href: '#services', label: 'Services' },
  { href: '#response', label: 'Response' },
  { href: '#coverage', label: 'Coverage' },
  { href: '#contact', label: 'Contact' },
] as const;

/**
 * The masthead stays at 11px and never grows.
 *
 * Every anchor here points at a real section id on this page — the nav is a
 * table of contents, not a set of links to pages that do not exist.
 */
export function SiteHeader() {
  return (
    <header className="absolute inset-x-0 top-0 z-40 px-[var(--gutter)] pt-[calc(var(--banner-h,3rem)+1rem)]">
      <div className="u-shell flex items-center justify-between gap-6">
        <a href="#top" className="u-label flex min-h-[44px] items-center gap-3 text-[10px]">
          <span
            aria-hidden="true"
            className="block h-2.5 w-2.5 border border-[color:var(--bone-50)] bg-[color:var(--signal-500)]"
          />
          <span className="leading-none text-[color:var(--bone-50)]">
            Black Bear
            <span className="ml-2 hidden text-[color:var(--steel-500)] sm:inline">Security &amp; Medical</span>
          </span>
        </a>

        <nav aria-label="Sections" className="hidden lg:block">
          <ul className="flex items-center gap-7">
            {links.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="u-label -my-3 inline-flex min-h-[44px] items-center text-[10px] text-[color:var(--steel-400)] transition-colors hover:text-[color:var(--bone-50)]"
                  style={{
                    transitionDuration: 'var(--t-state)',
                    transitionTimingFunction: 'var(--e-settle)',
                  }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <a
          href={business.telephoneHref}
          className="u-label hidden min-h-[44px] shrink-0 items-center text-[10px] text-[color:var(--bone-50)] transition-colors hover:text-[color:var(--signal-400)] sm:inline-flex"
          style={{ transitionDuration: 'var(--t-state)', transitionTimingFunction: 'var(--e-settle)' }}
        >
          {business.telephoneDisplay}
        </a>
      </div>
    </header>
  );
}
